class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.injectEuracomStyles();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    this.hideAddedNotice();
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      // EURACOM: il carrello non si apre più a ogni aggiunta.
      // Si aggiorna in background (contenuto + contatore) e compare una conferma discreta.
      this.showAddedNotice();
    });
  }

  /* ---------- EURACOM: conferma "prodotto aggiunto" ---------- */
  showAddedNotice() {
    let notice = document.getElementById('EuracomCartNotice');
    if (!notice) {
      notice = document.createElement('div');
      notice.id = 'EuracomCartNotice';
      notice.className = 'euracom-cart-notice';
      notice.setAttribute('role', 'status');
      notice.setAttribute('aria-live', 'polite');
      notice.innerHTML =
        '<span class="euracom-cart-notice__text">Prodotto aggiunto al carrello</span>' +
        '<button type="button" class="euracom-cart-notice__link">Vedi carrello</button>';
      notice.querySelector('button').addEventListener('click', () => {
        this.open(document.querySelector('#cart-icon-bubble'));
      });
      document.body.appendChild(notice);
    }
    clearTimeout(this.noticeTimer);
    // posizionata subito sotto l'header (o in alto se l'header è fuori vista):
    // in basso a destra ci sono già il pulsante privacy iubenda e il "torna su"
    const header = document.querySelector('.shopify-section-header');
    const headerBottom = header ? header.getBoundingClientRect().bottom : 0;
    notice.style.top = Math.max(16, Math.round(headerBottom) + 12) + 'px';
    notice.classList.remove('is-visible');
    void notice.offsetWidth;
    notice.classList.add('is-visible');
    this.noticeTimer = setTimeout(() => this.hideAddedNotice(), 4000);

    const bubble = document.querySelector('#cart-icon-bubble');
    if (bubble) {
      bubble.classList.remove('euracom-cart-bump');
      void bubble.offsetWidth;
      bubble.classList.add('euracom-cart-bump');
    }
  }

  hideAddedNotice() {
    clearTimeout(this.noticeTimer);
    const notice = document.getElementById('EuracomCartNotice');
    if (notice) notice.classList.remove('is-visible');
  }

  injectEuracomStyles() {
    if (document.getElementById('EuracomCartStyles')) return;
    const style = document.createElement('style');
    style.id = 'EuracomCartStyles';
    style.textContent = `
      /* EURACOM: pulsante "Procedi con l'ordine" nero, distinguibile dal fondo marrone */
      cart-drawer .cart__checkout-button.button,
      cart-drawer .cart__checkout-button.button:not([disabled]):hover {
        background-color: #000 !important;
        border-color: #000 !important;
        color: #fff !important;
      }
      cart-drawer .cart__checkout-button.button .button-label { color: #fff !important; }
      cart-drawer .cart__checkout-button.button:not([disabled]):hover { opacity: .85; }

      /* EURACOM: area totale del carrello grigio chiaro con testi neri (prima marrone) */
      cart-drawer .drawer__footer {
        background-color: #F2F2F2 !important;
        color: #000 !important;
      }
      cart-drawer .drawer__footer .totals,
      cart-drawer .drawer__footer .totals *,
      cart-drawer .drawer__footer .tax-note,
      cart-drawer .drawer__footer .tax-note a,
      cart-drawer .drawer__footer .button--simple,
      cart-drawer .drawer__footer .button--simple .button-label {
        color: #000 !important;
      }

      /* EURACOM: conferma aggiunta al carrello */
      .euracom-cart-notice {
        position: fixed;
        top: 16px;
        right: 24px;
        z-index: 2147483000;
        display: flex;
        align-items: center;
        gap: 16px;
        max-width: calc(100vw - 32px);
        padding: 14px 18px;
        background: #000;
        color: #fff;
        font-family: 'Montserrat', sans-serif;
        font-size: 14px;
        line-height: 1.3;
        box-shadow: 0 6px 24px rgba(0, 0, 0, .18);
        opacity: 0;
        transform: translateY(-12px);
        pointer-events: none;
        transition: opacity .25s ease, transform .25s ease;
      }
      .euracom-cart-notice.is-visible {
        opacity: 1;
        transform: translateY(0);
        pointer-events: auto;
      }
      .euracom-cart-notice__link {
        background: none;
        border: 0;
        padding: 0;
        color: #fff;
        font: inherit;
        font-weight: 700;
        text-decoration: underline;
        text-underline-offset: 3px;
        cursor: pointer;
        white-space: nowrap;
      }
      @media screen and (max-width: 749px) {
        .euracom-cart-notice {
          left: 16px;
          right: 16px;
          justify-content: space-between;
        }
      }
      #cart-icon-bubble.euracom-cart-bump { animation: euracomCartBump .5s ease; }
      @keyframes euracomCartBump {
        0%, 100% { transform: scale(1); }
        40% { transform: scale(1.18); }
      }
      @media (prefers-reduced-motion: reduce) {
        .euracom-cart-notice { transition: none; }
        #cart-icon-bubble.euracom-cart-bump { animation: none; }
      }
    `;
    document.head.appendChild(style);
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
